import { Link } from "react-router-dom";
import { textChooser } from "../../util/textChooser";
import successImg from "../../../assets/images/success.png";
import "./postulation.style.scss";
import {Button} from "../controls/button/button";

export default function PostulationSuccess() {
  return (
    <div className="postulation-container">
      <img 
        src={successImg} 
        alt="postulation success" 
        width={100} 
        height={100}
      />
      
      <h2>{textChooser('txt195')}</h2>
      <p>{textChooser('txt191')}</p>

      <Button primary>
        <Link to={"/"}>
          {textChooser('txt220')}
        </Link>
      </Button>
    </div>
  );
}